import '../css/privacyterm.css'

function member() {
    return (
        <div>
            <p>
                表格工坊App由广州野离子网络科技有限公司研发（以下简称“本应用”），为你提供会员增值服务。请你仔细阅读本会员服务协议，以便你了解我们关于会员服务的相关规则。
            </p>
            <h3>一、协议说明</h3>
            <p>
                本协议是《表格工坊用户协议》的补充协议，是其不可分割的组成部分。本协议与上述内容存在冲突的，以本协议为准。本协议内容同时包括表格工坊可能不断发布的关于本服务的相关协议、业务规则等内容。
            </p>

            <h3>二、关于本服务</h3>
            <p>
                会员服务，指按照表格工坊的指定方式支付一定服务费用之后，用户可以享有由表格工坊或第三方提供的在表格工坊产品特权的服务。表格工坊可能会根据不同的产品及服务类型，推出不同的增值服务，具体增值服务种类及服务内容以相关服务页面公布、实际提供的内容为准。
            </p>
            <p>
                您所享有的本服务的具体内容可能会因为级别、是否年费、开通期限、您选择的具体服务类别等因素而有不同，具体以相关服务页面公布、实际提供的内容为准。
            </p>

            <h3>三、收费与开通</h3>
            <p>
                本服务是表格工坊提供的收费服务，您须在按照本服务的收费标准支付相应费用后，方可使用本服务。表格工坊可能会根据本服务的整体规划，对本服务相关权益细则、收费标准、方式等进行修改和变更，前述修改、变更，表格工坊将在相应服务页面进行展示。
            </p>
            <table className="list" border={1}>
                <tr>
                    <th colSpan={3}>会员有效期说明</th>
                </tr>
                <tr>
                    <td>会员类型</td>
                    <td>有效期</td>
                    <td>备注</td>
                </tr>
                <tr>
                    <td>月度会员</td>
                    <td>开通时起31天</td>
                    <td>连续包月到期自动续费</td>
                </tr>
                <tr>
                    <td>季度会员</td>
                    <td>开通时起93天</td>
                    <td>连续包季到期自动续费</td>
                </tr>
                <tr>
                    <td>年度会员</td>
                    <td>开通时起365天</td>
                    <td>连续包年到期自动续费</td>
                </tr>
            </table>
            <p>
                您应该通过表格工坊指定的现有方式或今后表格工坊指定方式，在依约支付一定费用后开通本服务。本服务开通之后，不可进行转让。
            </p>

            <h3>四、行为规范</h3>
            <p>您在使用本服务时不得利用本服务从事以下行为：</p>
            <ul>
                <li>发布、传送、传播、储存违反国家法律、危害国家安全统一、社会稳定、公序良俗、社会公德以及侮辱、诽谤、淫秽、暴力的内容；</li>
                <li>发布、传送、传播、储存侵害他人名誉权、肖像权、知识产权、商业秘密等合法权利的内容；</li>
                <li>虚构事实、隐瞒真相以误导、欺骗他人；</li>
                <li>发表、传送、传播广告信息及垃圾信息；</li>
                <li>从事其他违反法律法规、政策及公序良俗、社会公德等的行为。</li>
            </ul>
            <p>
                本服务仅供您个人使用，除非经表格工坊书面许可，您不得通过任何方式搜集本服务中其他用户的个人信息，或将本服务再次许可他人使用。
            </p>

            <h3>五、违约责任</h3>
            <p>
                如果表格工坊发现或收到他人举报您有违反本协议任何行为的，表格工坊有权依法进行独立判断并采取技术手段予以删除、屏蔽或断开相关的信息。同时，表格工坊有权视您的行为性质，对您采取包括但不限于暂停或终止部分或全部本服务，追究您法律责任等措施，表格工坊也无需向您退还任何费用。
            </p>

            <h3>六、其他</h3>
            <p>
                本协议的成立、生效、履行、解释及纠纷解决，适用中华人民共和国大陆地区法律（不包括冲突法）。若您和表格工坊之间发生任何纠纷或争议，首先应友好协商解决；协商不成的，您同意将纠纷或争议提交广东省广州市有管辖权的人民法院管辖。
            </p>
            <p>
                如果用户对本条款内容有任何疑问，请联系我们的在线客服说明或发送邮件至 pengdeshen_2013@qq.com
            </p>

            <p>感谢你使用表格工坊App，我们将竭诚为你提供优质的会员服务！</p>
            <p style={{ marginTop: '20px', fontSize: 14 }}>更新日期：2026年4月28日<br />生效日期：2026年04月28日</p>
        </div>
    )
}

export default member;